(function(){
  function num(t){
    return parseFloat(String(t).replace(/[^\d,.]/g,'').replace(',','.'))||0;
  }
  // Precio base: 1ª fila de la tabla (Liquid, nunca lo toca Samy)
  function base(){
    var f = document.querySelector('#sk-vol .sk-vol__row[data-min="20"] div:last-child');
    if(f) return num(f.textContent);
    var p = document.querySelector('.price__text .price__number .money');
    return p ? num(p.textContent) : 0;
  }
  function tarifa(b,q){
    var f = q>=501 ? 0.80 : q>=201 ? 0.90 : 1;
    return Math.round(b*f*100)/100;
  }
  function render(){
    var box=document.getElementById('sk-resumen');
    if(!box) return;
    var t=document.querySelector('.product-single__title')||document.querySelector('h1');
    var q=document.querySelector('input[name="quantity"]');
    var c=document.querySelector('.product-form__swatch__input:checked');

    var cant=q?parseInt(q.value,10)||0:0;
    var ud=tarifa(base(),cant);
    var tot=ud*cant;
    var f=function(n){return n.toLocaleString('es-ES',{minimumFractionDigits:2,maximumFractionDigits:2});};

    box.querySelector('[data-sk="producto"]').textContent = t?t.textContent.trim():'';
    box.querySelector('[data-sk="color"]').textContent    = c?c.value:'—';
    box.querySelector('[data-sk="unidades"]').textContent = cant+' uds';
    box.querySelector('[data-sk="precio"]').textContent   = f(ud)+' €';
    box.querySelector('[data-sk="total"]').textContent    = f(tot)+' €';
  }
  function init(){
    if(!document.getElementById('sk-resumen')) return;
    render();
    document.addEventListener('input',render,true);
    document.addEventListener('change',render,true);
    document.addEventListener('click',function(){setTimeout(render,400);},true);
    [800,2000,3500].forEach(function(ms){setTimeout(render,ms);});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();